import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { SharedFormMessages as messages } from '../../shared/forms';
import { Question } from './Question';

export class TextQuestion extends React.Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }

  onChange() {
    this.props.updateAnswer(this.props.questionnaireItem.questionnaireItemId, this.input.value);
    if (this.props.questionnaireItem.isValid === false) {
      this.props.validateQuestionnaire();
    }
  }

  setAnswer = () => {
    const opts = {};
    opts.disabled = this.props.disabled;
    if (this.props.answerItem) {
      opts.value = this.props.answerItem.textAnswer;
    }
    return opts;
  }

  renderTextInput = (id, inputClassName) => (
    <input
      ref={ (input) => { this.input = input; } }
      type="text"
      data-qa-item={ id }
      className={"form-control " +  inputClassName} 
      onChange={ this.onChange }
      maxLength="2000"
      {...this.setAnswer()}
    />
  );

  renderTextArea = (id, inputClassName) => (
    <textarea
      ref={ (textarea) => { this.input = textarea; } }
      rows={ 3 }
      data-qa-item={ id }
      className={"form-control " +  inputClassName} 
      onChange={ this.onChange }
      maxLength="2000"
      {...this.setAnswer()}
    />
  );

  render() {
    const { questionnaireItem } = this.props;
    const textBoxId = 'text_question_' + questionnaireItem.questionNumber;
    const invalidQuestionId = 'question_is_invalid_' + questionnaireItem.questionNumber;
    const className = questionnaireItem.isValid === false
      ? 'form-group col-12 col-md-6 has-error is-invalid'
      : 'form-group col-12 col-md-6';
    const inputClassName = questionnaireItem.isValid === false ? 'is-invalid' : '';
    return (
      <div data-qa-item="text_question_type" className="question-area">
        <Question
          isValid={ questionnaireItem.isValid }
          questionNumber={questionnaireItem.questionNumber}
          formattedText={questionnaireItem.formattedText}
          isRequired={questionnaireItem.isRequired}
        />
        <div className="row">
         <div className={ className }>
            { questionnaireItem.isMultiLine ? this.renderTextArea(textBoxId, inputClassName) : this.renderTextInput(textBoxId, inputClassName) }
            {
            questionnaireItem.isValid === false
              ? <span data-qa-item={ invalidQuestionId } className="invalid-feedback">
                  <FormattedMessage {...messages.error.required} />
                </span>
              : null
          }
         </div>
        </div>
      </div>
    );
  }
}

TextQuestion.propTypes = {
  questionnaireItem: PropTypes.object,
  updateAnswer: PropTypes.func,
  validateQuestionnaire: PropTypes.func,
  disabled: PropTypes.bool,
  answerItem: PropTypes.object,
};
